import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, SwapActionCreators, IAppState, ILogisticsLookupDataResponse, IPositionResponse, ILogisticsOptionResponse, IDutyOfficerResponse, CenterActionCreators, ContactActionCreators } from '@nkr/store/index';
import { ICluster, IClusterListResponse, ILogisticsResponse, IBaseResponse, ILogisticsRequest, ILogistics, ILogisticsProvider, ITransportType, ILogisticsWithOption, ILogisticsOptionRequest, IContact, IExpandableSwaps, ICenterToCenterDistance } from '@nkr/models/index';
import { LogisticsAudience, CourierLogisticsConfirmationEmailType } from '@nkr/enums/index';
import { Panel, Glyphicon, Alert, FormControl, Button } from 'react-bootstrap';
import PositionList from './position-list';
import Logistics from '../swap-management/swaps/swap-list/logistics';
import LogisticsOption from '../swap-management/swaps/swap-list/logistics/option';
import { toast } from 'react-toastify';
import { IDutyOfficer } from '../../models/duty-officer';
import { downloadFile } from '@nkr/services/download-file';
import { warning } from 'react-icons-kit/fa/warning';
import Icon from 'react-icons-kit';

interface IProps { }

interface IStateProps {
    swaps: ICluster[],
    distanceBetweenCenters: ICenterToCenterDistance[],
    logisticsProviders: ILogisticsProvider[]
    transportTypes: ITransportType[],
    staffList: IContact[],
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getSwapsForCourier: (courierVendor: number) => Promise<IClusterListResponse>,
    getCurrentDutyOfficer: () => Promise<IDutyOfficerResponse>,
    getLogisticsLookupData: () => Promise<ILogisticsLookupDataResponse>,
    getLogisticsData: (donorId: number, recipientId: number) => Promise<ILogisticsResponse>,
    saveLogisticsData: (logistics: ILogisticsRequest) => Promise<IBaseResponse>,
    getLogisticsOption: (chainId: number, clusterNumber: number, positionNumber: number) => Promise<ILogisticsOptionResponse>,
    saveLogisticsOption: (request: ILogisticsOptionRequest) => Promise<ILogisticsOptionResponse>,
    refreshSwapForCourier: (chainId: number, clusterNumber: number, positionNumber: number) => Promise<IPositionResponse>,
    sendCourierEmail: (chainId: number, clusterNumber: number, positionMumber: number, emailType: number) => Promise<IBaseResponse>,
    getCenterAddressesDownload: (donorCenterId: number, recipCenterId: number, clusterId: number) => Promise<any>,
    getCenterContactsDownload: (clusterId: number) => Promise<any>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    selectedProvider: number,
    expanded: { key: string, chainId: number, clusterNumber: number }[],
    expandAll: boolean,
    logistics: {
        show: boolean,
        data: ILogistics,
        clusterId: number
    },
    options: {
        show: boolean,
        data: ILogisticsWithOption
    },
    dutyofficer: IDutyOfficer
}

class CourierLogistics extends React.Component<TProps, IState> {
    readonly state: IState = {
        selectedProvider: 0,
        expanded: [],
        expandAll: true,
        logistics: {
            show: false,
            data: null,
            clusterId: 0
        },
        options: {
            show: false,
            data: null
        },
        dutyofficer: null
    }

    dutyOfficerTimer: any;
    dutyOfficerTimeout = 60000;

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading swaps, one moment please...').then(() => {
            Promise
                .all([
                    this.props.getLogisticsLookupData(),
                    this.props.getSwapsForCourier(this.props.app.user.courierVendor),
                    this.props.getCurrentDutyOfficer()
                ])
                .then(([lookupDataResponse, swapsResponse, duryOfficerResponse]) => {
                    this.setState({
                        dutyofficer: duryOfficerResponse.data.result
                    });

                    this.dutyOfficerTimer = window.setTimeout(this.checkForDutyOfficer, this.dutyOfficerTimeout);
                    this.props.hideLoading();
                });
        });
    }

    refreshSwaps = () => {
        let courier = this.props.logisticsProviders.find(x => x.id == this.state.selectedProvider);
        let description = courier != null ? courier.description : 'all providers';

        this.props.showLoading('Retrieving swaps for ' + description + ', one moment please...').then(() => {
            this.props.getSwapsForCourier(this.state.selectedProvider).then(() => {
                this.props.hideLoading();
            });
        });

    }

    checkForDutyOfficer = () => {
        window.clearTimeout(this.dutyOfficerTimer);

        this.props.getCurrentDutyOfficer().then(async response => {
            if (response.data.success) {
                this.setState({
                    dutyofficer: response.data.result
                });
            }

            this.dutyOfficerTimer = window.setTimeout(this.checkForDutyOfficer, this.dutyOfficerTimeout);
        });
    }

    handleExpand = (chainId: number, clusterNumber: number) => {
        let expanded = _.cloneDeep(this.state.expanded);

        let f = expanded.find(x => x.key == chainId + '/' + clusterNumber);

        if (f != null) {
            expanded = expanded.filter(x => x.key != chainId + '/' + clusterNumber);
        } else {
            expanded.push({ key: chainId + '/' + clusterNumber, chainId, clusterNumber });
        }

        this.setState({
            expanded
        });
    }

    handleExpandAll = () => {
        let expanded = !this.state.expandAll ? [] : this.props.swaps.map(x => ({ key: x.chainId + '/' + x.clusterNumber, chainId: x.chainId, clusterNumber: x.clusterNumber }));

        this.setState({
            expanded,
            expandAll: !this.state.expandAll
        });
    }

    handleAddressDownload = (donorCenterId: number, recipientCenterId: number, clusterId: number) => {
        this.props.showLoading("Downloading File...").then(() => {

            this.props.getCenterAddressesDownload(donorCenterId, recipientCenterId, clusterId).then((response: any) => {
                downloadFile(response.data, `logistics_address_list.rtf`, 'application/rtf');

                this.props.hideLoading();
            });
        });
    }


    handleContactsDownload = (clusterId: number) => {
        this.props.showLoading("Downloading File...").then(() => {

            this.props.getCenterContactsDownload(clusterId).then((response: any) => {
                downloadFile(response.data, `logistics_contacts_list.csv`, 'text/csv');
                this.props.hideLoading();
            });
        });
    }


    handleOpenLogistics = (chainId: number, clusterNumber: number, positionNumber: number) => {
        let swap = this.props.swaps.find(x => x.chainId == chainId && x.clusterNumber == clusterNumber);
        let position = swap.positions.find(x => x.positionNumber == positionNumber);
        let { donor, recipient } = position;

        this.props.showLoading('Fetching logistic plans, one moment please...').then(() => {
            this.props.getLogisticsData(donor.id, recipient.id).then((response: ILogisticsResponse) => {
                var { success, results } = response.data;

                if (success) {
                    this.setState({
                        logistics: {
                            show: true,
                            data: results,
                            clusterId: swap.id
                        }
                    }, () => {
                        this.props.hideLoading();
                    });
                }
            });
        });
    }

    handleSaveLogistics = (logistics: ILogisticsRequest) => {
        let {
            kidneyPickupDateTimeActual: newPU,
            tenderedToAirlineActual: newTendered,
            flightDepartureTimeActual: newDeparture,
            leg2DepartureTimeActual: newLeg2Departure,
            recoveredFromAirlineActual: newRecovered,
            kidneyArrivalDateTimeActual: newDelivered,
            flightCarrierAndNumberActual,
            chainId,
            clusterNumber,
            position
        } = logistics;

        let {
            kidneyPickupDateTimeActual: oldPU,
            tenderedToAirlineActual: oldTendered,
            flightDepartureTimeActual: oldDeparture,
            leg2DepartureTimeActual: oldLeg2Departure,
            recoveredFromAirlineActual: oldRecovered,
            kidneyArrivalDateTimeActual: oldDelivered
        } = this.state.logistics.data;

        let doPU = newPU != null && newPU != '' && newPU != oldPU;
        let doTendered = newTendered != null && newTendered != '' && newTendered != oldTendered;
        let doDeparture = newDeparture != null && newDeparture != '' && newDeparture != oldDeparture;
        let doLeg2Departure = newLeg2Departure != null && newLeg2Departure != '' && newLeg2Departure != oldLeg2Departure;
        let doRecovered = newRecovered != null && newRecovered != '' && newRecovered != oldRecovered;
        let doDelivered = newDelivered != null && newDelivered != '' && newDelivered != oldDelivered;

        let emailType: CourierLogisticsConfirmationEmailType = CourierLogisticsConfirmationEmailType.Unknown;

        if (doPU) {
            emailType = CourierLogisticsConfirmationEmailType.PickupConfirmation;
        }

        if (doTendered) {
            emailType = CourierLogisticsConfirmationEmailType.TenderedConfirmation;
        }

        if ((doDeparture || doLeg2Departure) && flightCarrierAndNumberActual != '') {
            emailType = CourierLogisticsConfirmationEmailType.DepartureConfirmation;
        }

        if (doRecovered) {
            emailType = CourierLogisticsConfirmationEmailType.RecoveryConfirmation;
        }

        if (doDelivered) {
            emailType = CourierLogisticsConfirmationEmailType.DeliveryConfirmation;
        }

        this.props.showLoading('Saving logistic plans, one moment please...').then(() => {
            this.props.saveLogisticsData(logistics)
                .then(response => {
                    if (response.data.success) {
                        this.props.sendCourierEmail(chainId, clusterNumber, position, emailType)
                            .then(response => {
                                this.props.hideLoading();

                                if (response.data.success) {
                                    this.setState({
                                        logistics: {
                                            show: false,
                                            data: null,
                                            clusterId: 0
                                        }
                                    }, () => {
                                        this.props.refreshSwapForCourier(logistics.chainId, logistics.clusterNumber, logistics.position).then(() => {
                                            toast.success('Plans saved successfully!', {
                                                position: toast.POSITION.TOP_CENTER,
                                                autoClose: 3000
                                            });
                                        });
                                    });
                                }
                            })
                            .catch((error: any) => {
                                this.props.hideLoading();
                                toast.error('Unable to send the confirmatiomn email...', {
                                    position: toast.POSITION.TOP_CENTER,
                                    autoClose: 3000
                                });
                            });;
                    }
                })
                .catch((error: any) => {
                    this.props.hideLoading();
                    toast.error('An error occurred while saving the logistics data...', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000
                    });
                });
        });
    }

    handleCancelLogistics = () => {
        this.setState({
            logistics: {
                show: false,
                data: null,
                clusterId: 0
            }
        });
    }

    handleOpenOptions = (chainId: number, clusterNumber: number, positionNumber: number) => {
        this.props.showLoading('Fetching logistic options, one moment please...').then(() => {
            this.props.getLogisticsOption(chainId, clusterNumber, positionNumber).then((response: ILogisticsOptionResponse) => {
                var { success, results } = response.data;

                if (success) {
                    this.setState({
                        options: {
                            show: true,
                            data: results
                        }
                    }, () => {
                        this.props.hideLoading();
                    });
                }
            });
        });
    }

    handleSaveOptions = (request: ILogisticsOptionRequest) => {
        this.props.showLoading('Saving logistic options, one moment please...').then(() => {
            this.props.saveLogisticsOption(request).then((response: ILogisticsOptionResponse) => {
                this.props.hideLoading();

                var { success } = response.data;

                if (success) {
                    this.setState({
                        options: {
                            show: false,
                            data: null,
                        }
                    }, () => {
                        this.props.getSwapsForCourier(this.props.app.user.courierVendor).then(() => {
                            toast.success('Options saved successfully!', {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 3000
                            });
                        });
                    });
                }
            });
        });
    }

    handleCancelOptions = () => {
        this.setState({
            options: {
                show: false,
                data: null
            }
        });
    }

    handleProviderChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            selectedProvider: parseInt(e.currentTarget.value)
        }, () => {
            this.refreshSwaps();
        });
    }

    renderDutyOfficer = () => {
        return (
            <Alert bsStyle='info' style={{ padding: '7.5px 15px', marginBottom: 0 }}>
                {this.state.dutyofficer != null ?
                    <div style={{ display: 'flex' }}>
                        <div style={{ marginRight: 10 }}>
                            For any questions regarding an ongoing move please contact the officer on duty:
                        </div>
                        <div style={{ fontWeight: 600 }}>
                            {this.state.dutyofficer.name}&nbsp;|&nbsp;
                            {this.state.dutyofficer.phoneNumber}&nbsp;|&nbsp;
                            {this.state.dutyofficer.email}
                        </div>
                    </div>
                    :
                    <>One moment please...</>
                }
            </Alert>
        );
    }

    render = () => {
        const swaps = _.orderBy(this.props.swaps, [(swap) => {
            return swap.chainId;
        }, (swap) => {
            return swap.clusterNumber;
        }]);

        return (
            <>
                <div className='container-fluid'>
                    <div className='row' style={{ marginBottom: 20 }}>
                        <div className='col-xs-3 col-lg-12'>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <h1 style={{ margin: 0 }}>Swap Logistics</h1>
                                </div>

                                {this.props.app.user.group.isSuper && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ marginRight: 5 }}>Show&nbsp;swaps&nbsp;for:</div>
                                        <FormControl
                                            componentClass='select'
                                            value={this.state.selectedProvider}
                                            onChange={this.handleProviderChange}
                                        >
                                            <option value={0}>- All Providers -</option>
                                            {this.props.logisticsProviders.filter(item => item.isActive).map(item =>
                                                <option value={item.id}>{item.description}</option>
                                            )}
                                        </FormControl>
                                    </div>
                                )}

                                <div>
                                    {this.renderDutyOfficer()}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <div>
                            <Button onClick={this.handleExpandAll}>{!this.state.expandAll ? 'Expand All' : 'Collapse All'}</Button>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            {/* <div style={{ paddingRight: 10 }}>Legend:</div> */}
                            <div style={{ marginRight: 20 }}>
                                <Icon icon={warning} style={{ color: '#a2a5a6' }} /> - no options
                            </div>
                            <div style={{ marginRight: 20 }}>
                                <Icon icon={warning} style={{ color: 'purple' }} /> - existing draft options
                            </div>
                            <div style={{ marginRight: 20 }}>
                                <Icon icon={warning} style={{ color: '#4f82e0' }} /> - options submitted to NKR
                            </div>
                            <div style={{ marginRight: 20 }}>
                                <Icon icon={warning} style={{ color: '#e0a44f' }} /> - options submitted to center
                            </div>
                            <div style={{ marginRight: 20 }}>
                                <Icon icon={warning} style={{ color: '#64b06b' }} /> - option selected by center
                            </div>
                        </div>
                    </div>

                    <div style={{ width: '100%', height: '85vh', overflow: 'auto', overflowX: 'hidden' }}>
                        <div className='row'>
                            <div className='col-xs-12 col-lg-12'>
                                {swaps.map((swap, index) => {
                                    let isExpanded = this.state.expanded.find(x => x.chainId == swap.chainId && x.clusterNumber == swap.clusterNumber) != null;

                                    return (
                                        <Panel key={index} expanded={isExpanded} onToggle={() => null}>
                                            <Panel.Heading style={{ display: 'flex', cursor: 'default' }} onClick={() => this.handleExpand(swap.chainId, swap.clusterNumber)}>
                                                <div style={{ marginRight: 10 }}><Glyphicon glyph={isExpanded ? 'triangle-bottom' : 'triangle-top'} /></div>
                                                <Panel.Title>{swap.chainId}/{swap.clusterNumber}</Panel.Title>
                                            </Panel.Heading>
                                            <Panel.Collapse>
                                                <Panel.Body>
                                                    <PositionList
                                                        positions={swap.positions}
                                                        staffList={this.props.staffList}
                                                        onOpenLogistics={this.handleOpenLogistics}
                                                        onOpenOptions={this.handleOpenOptions}
                                                    />
                                                </Panel.Body>
                                            </Panel.Collapse>
                                        </Panel>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>

                <Logistics
                    show={this.state.logistics.show}
                    clusterId={this.state.logistics.clusterId}
                    data={this.state.logistics.data}
                    logisticsProviders={this.props.logisticsProviders}
                    transportTypes={this.props.transportTypes}
                    distanceBetweenCentersList={this.props.distanceBetweenCenters}
                    logisticsList={[]}
                    forCourier={true}
                    onSwitchToLogisticsPlan={() => null}
                    onSave={this.handleSaveLogistics}
                    onCancel={this.handleCancelLogistics}
                    onAddressesExport={this.handleAddressDownload}
                    onContactsExport={this.handleContactsDownload}
                />

                <LogisticsOption
                    show={this.state.options.show}
                    data={this.state.options.data}
                    logisticsProviders={this.props.logisticsProviders}
                    transportTypes={this.props.transportTypes}
                    audience={LogisticsAudience.Courier}
                    user={this.props.app.user}
                    onSwitchToSwapLogistics={() => null}
                    onSave={this.handleSaveOptions}
                    onDelete={() => null}
                    onReturn={() => null}
                    onCancel={this.handleCancelOptions}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        swaps: state.swaps.list,
        distanceBetweenCenters: state.swaps.distanceBetweenCenters,
        logisticsProviders: state.swaps.logisticsProviders,
        transportTypes: state.swaps.transportTypeList,
        staffList: state.swaps.staffList,
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getSwapsForCourier: (courierVendor) => {
            return dispatch(SwapActionCreators.getSwapsForCourier(courierVendor));
        },
        refreshSwapForCourier: (chainId, clusterNumber, positionNumber) => {
            return dispatch(SwapActionCreators.refreshSwapForCourier(chainId, clusterNumber, positionNumber));
        },
        getCurrentDutyOfficer: () => {
            return dispatch(SwapActionCreators.getCurrentDutyOfficer());
        },
        getLogisticsLookupData: () => {
            return dispatch(SwapActionCreators.getLogisticsLookupData());
        },
        getLogisticsData: (donorId, recipientId) => {
            return dispatch(SwapActionCreators.getLogisticsDataByDonorRecipientForCourier(donorId, recipientId));
        },
        saveLogisticsData: (logistics) => {
            return dispatch(SwapActionCreators.saveLogisticsData(logistics));
        },
        getLogisticsOption: (chainId, clusterNumber, positionNumber) => {
            return dispatch(SwapActionCreators.getLogisticsOption(chainId, clusterNumber, positionNumber));
        },
        saveLogisticsOption: (request) => {
            return dispatch(SwapActionCreators.saveLogisticsOption(request, false));
        },
        sendCourierEmail: (chainId, clusterNumber, positionMumber, emailType) => {
            return dispatch(SwapActionCreators.sendCourierEmail(chainId, clusterNumber, positionMumber, emailType));
        },
        getCenterAddressesDownload: (donorCenterId, recipCenterId, clusterId) => {
            return dispatch(CenterActionCreators.getCenterAddressesDownload(donorCenterId, recipCenterId, clusterId));
        },
        getCenterContactsDownload: (clusterId) => {
            return dispatch(ContactActionCreators.getContactResultsForLogistics(clusterId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CourierLogistics);